import React from 'react';
import { SchematicShell, Line } from './SchematicPrimitives';

const LOWER_FRAC = 0.38;
const SEAM_GAP_FRAC = 0.03;

export function DormPrinterSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  const span = view === 'left' || view === 'right' ? depth : width;

  return (
    <SchematicShell
      width={span}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      <g
        transform={
          view === 'right' ? `scale(-1, 1) translate(${-span}, 0)` : undefined
        }
      >
        <PrinterElevation
          span={span}
          height={height}
          isSide={view === 'left' || view === 'right'}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
        />
      </g>
    </SchematicShell>
  );
}

function PrinterElevation({ span, height, isSide, strokeColor, strokeWidth }) {
  const lowerH = height * LOWER_FRAC;
  const seamGap = height * SEAM_GAP_FRAC;
  const upperH = height - lowerH - seamGap;
  const upperTop = 0;
  const upperBot = upperH;
  const lowerTop = upperH + seamGap;
  const lowerBot = height;

  const slotInset = span * 0.12;
  const slotW = span - slotInset * 2;
  const slotH = height * 0.08;
  const paperH = height * 0.35;

  const handleW = span * 0.18;
  const handleH = height * 0.08;

  return (
    <g>
      <rect
        x={0}
        y={upperTop}
        width={span}
        height={upperH}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
      <rect
        x={0}
        y={lowerTop}
        width={span}
        height={lowerH}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />

      {!isSide && (
        <>
          <rect
            x={slotInset}
            y={upperTop}
            width={slotW}
            height={slotH}
            fill="none"
            stroke={strokeColor}
            strokeWidth={strokeWidth * 0.7}
            vectorEffect="non-scaling-stroke"
          />
          <Line
            x1={span * 0.3}
            y1={-paperH * 0.15}
            x2={span * 0.3}
            y2={slotH}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth * 0.5}
          />
          <Line
            x1={span * 0.7}
            y1={-paperH * 0.15}
            x2={span * 0.7}
            y2={slotH}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth * 0.5}
          />
          <Line
            x1={span * 0.3}
            y1={-paperH * 0.15}
            x2={span * 0.7}
            y2={-paperH * 0.15}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth * 0.5}
          />
        </>
      )}

      {isSide && (
        <path
          d={`M ${span * 0.3} ${slotH} L ${span * 0.3} ${-paperH * 0.3} Q ${span * 0.5} ${-paperH * 0.4} ${span * 0.7} ${-paperH * 0.2}`}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth * 0.5}
          vectorEffect="non-scaling-stroke"
        />
      )}

      <rect
        x={(span - handleW) / 2}
        y={lowerTop + (lowerH - handleH) / 2}
        width={handleW}
        height={handleH}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth * 0.7}
        vectorEffect="non-scaling-stroke"
      />
    </g>
  );
}

DormPrinterSchematic.supportsSideViews = true;
